module.exports = __webpack_public_path__ + "img/ssss_active.e502fe2e.png";